<template>
  <div class="wrapper">
    <div class="main">
      <div class="section special-first-section-top">
        <div class="container text-center">
          <h1 class="title">
            {{ $t("home.title1") }}<br />
            {{ $t("home.title2") }}
          </h1>
        </div>

        <div class="home-projects-section">
          <div :class="isMobileDevice ? 'container' : 'home-container'">
            <div class="md-layout">
              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverYoyolumi = true"
                @mouseout="isHoverYoyolumi = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/yoyolumi`">
                  <img v-show="isHoverYoyolumi" :src="yoyolumi_cn_hover" />
                  <img v-show="!isHoverYoyolumi" :src="yoyolumi_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/yoyolumi`">
                  <img v-show="isHoverYoyolumi" :src="yoyolumi_hover" />
                  <img v-show="!isHoverYoyolumi" :src="yoyolumi" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverYoyolumi = true"
                @mouseout="isHoverYoyolumi = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/yoyolumi`">
                  <img :src="yoyolumi_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/yoyolumi`">
                  <img :src="yoyolumi_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverDiscovery = true"
                @mouseout="isHoverDiscovery = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/discovery`">
                  <img v-show="isHoverDiscovery" :src="discovery_cn_hover" />
                  <img v-show="!isHoverDiscovery" :src="discovery_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/discovery`">
                  <img v-show="isHoverDiscovery" :src="discovery_hover" />
                  <img v-show="!isHoverDiscovery" :src="discovery" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-100 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverDiscovery = true"
                @mouseout="isHoverDiscovery = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/discovery`">
                  <img :src="discovery_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/discovery`">
                  <img :src="discovery_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverAvatar = true"
                @mouseout="isHoverAvatar = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/avatar`">
                  <img v-show="isHoverAvatar" :src="avatar_cn_hover" />
                  <img v-show="!isHoverAvatar" :src="avatar_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/avatar`">
                  <img v-show="isHoverAvatar" :src="avatar_hover" />
                  <img v-show="!isHoverAvatar" :src="avatar" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverAvatar = true"
                @mouseout="isHoverAvatar = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/avatar`">
                  <img :src="avatar_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/avatar`">
                  <img :src="avatar_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverSystem = true"
                @mouseout="isHoverSystem = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/system`">
                  <img v-show="isHoverSystem" :src="system_cn_hover" />
                  <img v-show="!isHoverSystem" :src="system_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/system`">
                  <img v-show="isHoverSystem" :src="system_hover" />
                  <img v-show="!isHoverSystem" :src="system" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverSystem = true"
                @mouseout="isHoverSystem = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/system`">
                  <img :src="system_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/system`">
                  <img :src="system_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverConcert = true"
                @mouseout="isHoverConcert = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/concert`">
                  <img v-show="isHoverConcert" :src="concert_cn_hover" />
                  <img v-show="!isHoverConcert" :src="concert_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/concert`">
                  <img v-show="isHoverConcert" :src="concert_hover" />
                  <img v-show="!isHoverConcert" :src="concert" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverConcert = true"
                @mouseout="isHoverConcert = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/concert`">
                  <img :src="concert_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/concert`">
                  <img :src="concert_hover" />
                </router-link>
              </div>

              <div
                v-if="!isMobileDevice"
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical desktop-img-fill-in"
                @mouseover="isHoverSFDW = true"
                @mouseout="isHoverSFDW = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/sfdw`">
                  <img v-show="isHoverSFDW" :src="sfdw_cn_hover" />
                  <img v-show="!isHoverSFDW" :src="sfdw_cn" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/sfdw`">
                  <img v-show="isHoverSFDW" :src="sfdw_hover" />
                  <img v-show="!isHoverSFDW" :src="sfdw" />
                </router-link>
              </div>
              <div
                v-else
                class="md-layout-item md-size-50 md-small-size-100 grid-item-speical-mobile"
                @mouseover="isHoverSFDW = true"
                @mouseout="isHoverSFDW = false"
              >
                <router-link v-if="isCN" :to="`/${$i18n.locale}/sfdw`">
                  <img :src="sfdw_cn_hover" />
                </router-link>
                <router-link v-else :to="`/${$i18n.locale}/sfdw`">
                  <img :src="sfdw_hover" />
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import router from "@/router";
import Yoyolumi from "./Yoyolumi.vue";

export default {
  components: {},
  name: "home",
  bodyClass: "home-page",
  props: {
    yoyolumi: {
      type: String,
      default: require("@/assets/img/home/yoyolumi.png")
    },
    discovery: {
      type: String,
      default: require("@/assets/img/home/discovery.png")
    },
    avatar: {
      type: String,
      default: require("@/assets/img/home/avatar.png")
    },
    system: {
      type: String,
      default: require("@/assets/img/home/system.png")
    },
    concert: {
      type: String,
      default: require("@/assets/img/home/concert.png")
    },
    sfdw: {
      type: String,
      default: require("@/assets/img/home/sfdw.png")
    },
    yoyolumi_hover: {
      type: String,
      default: require("@/assets/img/home/yoyolumi_hover.png")
    },
    discovery_hover: {
      type: String,
      default: require("@/assets/img/home/discovery_hover.png")
    },
    avatar_hover: {
      type: String,
      default: require("@/assets/img/home/avatar_hover.png")
    },
    system_hover: {
      type: String,
      default: require("@/assets/img/home/system_hover.png")
    },
    concert_hover: {
      type: String,
      default: require("@/assets/img/home/concert_hover.png")
    },
    sfdw_hover: {
      type: String,
      default: require("@/assets/img/home/sfdw_hover.png")
    },
    discovery_cn: {
      type: String,
      default: require("@/assets/img/home/discovery_cn.png")
    },
    avatar_cn: {
      type: String,
      default: require("@/assets/img/home/avatar_cn.png")
    },
    system_cn: {
      type: String,
      default: require("@/assets/img/home/system_cn.png")
    },
    concert_cn: {
      type: String,
      default: require("@/assets/img/home/concert_cn.png")
    },
    sfdw_cn: {
      type: String,
      default: require("@/assets/img/home/sfdw_cn.png")
    },
    discovery_cn_hover: {
      type: String,
      default: require("@/assets/img/home/discovery_cn_hover.png")
    },
    avatar_cn_hover: {
      type: String,
      default: require("@/assets/img/home/avatar_cn_hover.png")
    },
    system_cn_hover: {
      type: String,
      default: require("@/assets/img/home/system_cn_hover.png")
    },
    concert_cn_hover: {
      type: String,
      default: require("@/assets/img/home/concert_cn_hover.png")
    },
    sfdw_cn_hover: {
      type: String,
      default: require("@/assets/img/home/sfdw_cn_hover.png")
    }
  },
  data() {
    return {
      isMobileDevice: this.$isMobile,
      isCN: false,
      isHoverYoyolumi: false,
      isHoverDiscovery: false,
      isHoverAvatar: false,
      isHoverSystem: false,
      isHoverConcert: false,
      isHoverSFDW: false
    };
  },
  watch: {
    "$route.path": {
      handler: function(path) {
        if (path.includes("en")) {
          this.isCN = false;
        } else {
          this.isCN = true;
        }
      },
      deep: true,
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.grid-item-speical {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 10px;
  padding-left: 10px;
  cursor: pointer;
}
.grid-item-speical-mobile {
  padding-top: 8px;
  padding-bottom: 8px;
  padding-right: 0px !important;
  padding-left: 0px !important;
  cursor: pointer;
}
.home-container,
.home-container-fluid {
  max-width: 1440px;
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  position: relative;

  .section & {
    flex-direction: column;
  }
}
.home-projects-section {
  padding-top: 15% !important;
}
.desktop-img-fill-in {
  img {
    min-width: 100%;
    min-height: 100%;
    width: auto;
    height: auto;
  }
}
</style>
